class BundleOptions extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("data-section-id");
    this.onQuantityChange = this.updateActiveState.bind(this);
  }

  get quantityInput() {
    return document.querySelector(`#Quantity-${this.sectionId}`);
  }

  get buttons() {
    return this.querySelectorAll(".bundle-options__item[data-quantity]");
  }

get discountMessage() {
  // Looks outside the component to the parent wrapper
  return this.closest('.bundle-wrapper')?.querySelector(".bundle-options__discount-message");
}

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.quantityInput) {
      console.warn("Bundle Options: Could not find quantity input");
      return;
    }

    this.addEventListener("click", this.handleClick.bind(this));
    this.quantityInput.addEventListener("input", this.onQuantityChange);
    this.quantityInput.addEventListener("change", this.onQuantityChange);

    this.updateActiveState();
  }

  handleClick(event) {
    const button = event.target.closest("[data-quantity]");
    if (!button) return;

    event.preventDefault();

    const quantity = parseInt(button.dataset.quantity, 10);
    if (!quantity || !this.quantityInput) return;

    this.setQuantity(quantity);
  }

  setQuantity(quantity) {
    this.quantityInput.value = quantity;
    this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

    const quantityElement = this.quantityInput.closest("quantity-input");
    quantityElement?.updateQuantity?.();

    this.updateActiveState();
  }

  updateActiveState() {
    if (!this.quantityInput) return;

    const currentQuantity = parseInt(this.quantityInput.value, 10);

    this.buttons.forEach((button) => {
      const isActive =
        parseInt(button.dataset.quantity, 10) === currentQuantity;

      button.classList.toggle("bundle-options__item--active", isActive);
    });

    if (this.discountMessage) {
      this.discountMessage.style.display =
        currentQuantity === 6 || currentQuantity === 12 ? "block" : "none";
    }
  }

  disconnectedCallback() {
    if (this.quantityInput) {
      this.quantityInput.removeEventListener("input", this.onQuantityChange);
      this.quantityInput.removeEventListener("change", this.onQuantityChange);
    }
  }
}

customElements.define("bundle-options", BundleOptions);